document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const drawer = document.querySelector('[data-mobile-drawer]');
  const drawerOpen = document.querySelector('[data-drawer-open]');
  const drawerClosers = document.querySelectorAll('[data-drawer-close]');

  const setDrawer = (open) => {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    drawerOpen?.setAttribute('aria-expanded', String(open));
    body.classList.toggle('menu-open', open);
  };

  drawerOpen?.addEventListener('click', () => setDrawer(true));
  drawerClosers.forEach((button) => button.addEventListener('click', () => setDrawer(false)));

  const searchOverlay = document.querySelector('[data-search-overlay]');
  const searchOpeners = document.querySelectorAll('[data-search-open]');
  const searchClosers = document.querySelectorAll('[data-search-close]');
  const searchInput = searchOverlay?.querySelector('input[type="search"]');

  const setSearch = (open) => {
    if (!searchOverlay) return;
    searchOverlay.classList.toggle('is-open', open);
    searchOverlay.setAttribute('aria-hidden', String(!open));
    body.classList.toggle('search-open', open);
    if (open) window.setTimeout(() => searchInput?.focus(), 120);
  };

  searchOpeners.forEach((button) => button.addEventListener('click', () => setSearch(true)));
  searchClosers.forEach((button) => button.addEventListener('click', () => setSearch(false)));

  document.querySelectorAll('[data-faq-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const item = button.closest('[data-faq-item]');
      const answer = item?.querySelector('[data-faq-answer]');
      if (!item || !answer) return;
      const open = item.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(open));
      answer.style.maxHeight = open ? `${answer.scrollHeight}px` : '0px';
    });
  });

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });

  const sizeGuide = document.querySelector('[data-size-guide]');
  const setSizeGuide = (open) => {
    if (!sizeGuide) return;
    sizeGuide.classList.toggle('is-open', open);
    sizeGuide.setAttribute('aria-hidden', String(!open));
    body.classList.toggle('size-guide-open', open);
  };
  document.querySelectorAll('[data-size-guide-open]').forEach((button) => button.addEventListener('click', () => setSizeGuide(true)));
  document.querySelectorAll('[data-size-guide-close]').forEach((button) => button.addEventListener('click', () => setSizeGuide(false)));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setDrawer(false);
      setSearch(false);
      setSizeGuide(false);
    }
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const form = root.querySelector('[data-product-form]');
    if (!form) return;

    const variantsScript = form.querySelector('[data-product-variants]');
    const lowStockThreshold = Number(root.dataset.lowStockThreshold || 5);
    let variants = [];
    try {
      variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    } catch (error) {
      console.error('Unable to read product variants.', error);
    }

    const idInput = form.querySelector('[data-variant-id]');
    const selector = form.querySelector('[data-variant-select]');
    const optionGroups = [...form.querySelectorAll('[data-option-position]')];
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-product-compare-price]');
    const sale = root.querySelector('[data-product-sale]');
    const status = form.querySelector('[data-product-status]');
    const submit = form.querySelector('[type="submit"][name="add"]');
    const addLabel = form.querySelector('[data-add-label]');
    const addPrice = form.querySelector('[data-add-price]');
    const mobileBar = document.querySelector('[data-mobile-product-bar]');
    const mobilePrice = mobileBar?.querySelector('[data-mobile-price]');
    const stickyAdd = mobileBar?.querySelector('[data-sticky-add]');
    const stickyLabel = mobileBar?.querySelector('[data-sticky-label]');

    const selectedOptions = () => optionGroups.map((group) => group.querySelector('.is-selected')?.dataset.optionValue || '');

    const findVariant = () => {
      if (!variants.length) return null;
      if (!optionGroups.length) return variants.find((variant) => String(variant.id) === String(idInput?.value)) || variants[0];
      const values = selectedOptions();
      return variants.find((variant) => variant.options.every((option, index) => String(option) === String(values[index])));
    };

    const updateOptionAvailability = () => {
      if (!variants.length || !optionGroups.length) return;
      const current = selectedOptions();
      optionGroups.forEach((group, groupIndex) => {
        group.querySelectorAll('[data-option-value]').forEach((button) => {
          const candidate = [...current];
          candidate[groupIndex] = button.dataset.optionValue;
          const possible = variants.some((variant) => variant.available && variant.options.every((option, index) => {
            if (index === groupIndex) return String(option) === String(candidate[index]);
            return !candidate[index] || String(option) === String(candidate[index]);
          }));
          button.classList.toggle('is-unavailable', !possible);
        });
      });
    };

    const renderStatus = (variant) => {
      if (!status || !variant) return;
      if (!variant.available) {
        status.innerHTML = '<span class="product-form__status-dot product-form__status-dot--sold"></span>Currently sold out';
        return;
      }
      if (variant.inventoryManagement && variant.inventoryQuantity > 0 && variant.inventoryQuantity <= lowStockThreshold) {
        status.innerHTML = `<span class="product-form__status-dot product-form__status-dot--low"></span>Only ${variant.inventoryQuantity} left in stock`;
        return;
      }
      status.innerHTML = '<span class="product-form__status-dot"></span>In stock and ready to dispatch';
    };

    const updateVariant = (variant, updateUrl = true) => {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (selector) selector.value = String(variant.id);
      if (price) price.textContent = variant.price;
      if (mobilePrice) mobilePrice.textContent = variant.price;
      if (addPrice) addPrice.textContent = variant.price;

      if (compare) {
        compare.textContent = variant.comparePrice || '';
        compare.hidden = !variant.comparePrice;
      }

      if (sale) {
        const percent = variant.compareRaw > variant.priceRaw
          ? Math.round(((variant.compareRaw - variant.priceRaw) / variant.compareRaw) * 100)
          : 0;
        sale.textContent = percent ? `Save ${percent}%` : '';
        sale.hidden = !percent;
      }

      [submit, stickyAdd].forEach((button) => {
        if (button) button.disabled = !variant.available;
      });
      if (addLabel) addLabel.textContent = variant.available ? submit?.dataset.addText || 'Add to cart' : submit?.dataset.soldText || 'Sold out';
      if (stickyLabel) stickyLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      renderStatus(variant);
      updateOptionAvailability();

      if (updateUrl && window.history.replaceState && variant.url) {
        window.history.replaceState({}, '', variant.url);
      }
    };

    optionGroups.forEach((group) => {
      group.querySelectorAll('[data-option-value]').forEach((button) => {
        button.addEventListener('click', () => {
          group.querySelectorAll('[data-option-value]').forEach((item) => {
            const selected = item === button;
            item.classList.toggle('is-selected', selected);
            item.setAttribute('aria-pressed', String(selected));
          });
          const variant = findVariant();
          if (variant) updateVariant(variant);
          else updateOptionAvailability();
        });
      });
    });

    selector?.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === String(selector.value));
      if (!variant) return;
      optionGroups.forEach((group, index) => {
        group.querySelectorAll('[data-option-value]').forEach((button) => {
          const selected = String(button.dataset.optionValue) === String(variant.options[index]);
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
      });
      updateVariant(variant);
    });

    const quantityInput = form.querySelector('[data-quantity-input]');
    form.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      if (!quantityInput) return;
      quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);
    });
    form.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      if (!quantityInput) return;
      quantityInput.value = Math.max(1, Number(quantityInput.value || 1) + 1);
    });

    stickyAdd?.addEventListener('click', () => {
      if (!stickyAdd.disabled) form.requestSubmit(submit);
    });

    updateOptionAvailability();
  });

  document.querySelectorAll('[data-gallery-wrap]').forEach((wrap) => {
    const gallery = wrap.querySelector('[data-product-gallery]');
    const slides = [...wrap.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...wrap.querySelectorAll('[data-gallery-thumb]')];
    const thumbsTrack = wrap.querySelector('[data-gallery-thumbs]');
    const previous = wrap.querySelector('[data-gallery-prev]');
    const next = wrap.querySelector('[data-gallery-next]');
    const thumbPrevious = wrap.querySelector('[data-thumb-prev]');
    const thumbNext = wrap.querySelector('[data-thumb-next]');
    const counter = wrap.querySelector('[data-gallery-current]');
    if (!gallery || !slides.length) return;

    let activeIndex = 0;
    let scrollFrame = null;

    const setActive = (index, scrollThumb = true) => {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === activeIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (counter) counter.textContent = String(activeIndex + 1);
      if (previous) previous.disabled = activeIndex === 0;
      if (next) next.disabled = activeIndex === slides.length - 1;
      if (scrollThumb && thumbs[activeIndex]) {
        thumbs[activeIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    };

    const goTo = (index) => {
      const target = slides[Math.max(0, Math.min(index, slides.length - 1))];
      if (!target) return;
      gallery.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      setActive(index);
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        goTo(index);
      });
    });

    previous?.addEventListener('click', () => goTo(activeIndex - 1));
    next?.addEventListener('click', () => goTo(activeIndex + 1));
    thumbPrevious?.addEventListener('click', () => thumbsTrack?.scrollBy({ left: -240, behavior: 'smooth' }));
    thumbNext?.addEventListener('click', () => thumbsTrack?.scrollBy({ left: 240, behavior: 'smooth' }));

    gallery.addEventListener('scroll', () => {
      if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(() => {
        const width = gallery.clientWidth || 1;
        const index = Math.round(gallery.scrollLeft / width);
        if (index !== activeIndex) setActive(index);
      });
    }, { passive: true });

    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') goTo(activeIndex - 1);
      if (event.key === 'ArrowRight') goTo(activeIndex + 1);
    });

    window.addEventListener('resize', () => {
      gallery.scrollLeft = slides[activeIndex]?.offsetLeft || 0;
    });

    setActive(0, false);
  });

  document.querySelectorAll('[data-product-recommendations]').forEach((section) => {
    const url = section.dataset.url;
    if (!url) return;
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = html.querySelector('[data-product-recommendations]');
        if (recommendations?.innerHTML.trim()) section.innerHTML = recommendations.innerHTML;
      })
      .catch(() => {});
  });
});
